import { render } from "./loginAdmin.vue?vue&type=template&id=03066765&scoped=true"
import script from "./loginAdmin.vue?vue&type=script&lang=js"
export * from "./loginAdmin.vue?vue&type=script&lang=js"

import "./loginAdmin.vue?vue&type=style&index=0&id=03066765&scoped=true&lang=css"

import exportComponent from "/Users/mwint/Documents/Github/app-vybroo-net/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03066765"]])

export default __exports__